import { atom, selector } from 'recoil'
import { IUser } from '../types/types'
import { api } from '../utils/api'

const fetchUsers = async (): Promise<IUser[]> => {
  const { data } = await api.get('/users')
  return data.users
}

export const usersState = atom<IUser[]>({
  key: 'usersState',
  default: selector({
    key: 'usersState/Default',
    get: async (): Promise<IUser[]> => fetchUsers(),
  }),
})